import { useEffect, useState } from 'react';
import { AuditLog } from './views/AuditLog';
import { Tenants } from './views/Tenants';
import { LoginForm } from './views/LoginForm';
import { UserIdentity } from './views/UserIdentity';
import { BackendHealth } from './views/BackendHealth';
import { Toast } from './views/Toast';
import { isAuthenticated, logout, onAuthChanged } from './auth';

type ViewId = 'tenants' | 'audit';

export function App() {
  const [view, setView] = useState<ViewId>('tenants');
  const [authed, setAuthed] = useState<boolean>(isAuthenticated());

  useEffect(() => {
    return onAuthChanged(() => setAuthed(isAuthenticated()));
  }, []);

  if (!authed) {
    return (
      <div className="app">
        <header className="app-header">
          <h1>KeyForge</h1>
          <span className="app-header-tagline">Sign in required</span>
        </header>
        <main className="app-main">
          <LoginForm onLoggedIn={() => setAuthed(true)} />
        </main>
        <Toast />
        <footer className="app-footer">
          <span>KeyForge PWA · v0.1.0</span>
        </footer>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>KeyForge</h1>
        <nav>
          <button onClick={() => setView('tenants')} className={view === 'tenants' ? 'active' : ''}>
            Tenants
          </button>
          <button onClick={() => setView('audit')} className={view === 'audit' ? 'active' : ''}>
            Audit Log
          </button>
        </nav>
        <BackendHealth />
        <UserIdentity />
        <button onClick={() => logout()} className="logout-btn" title="Sign out">
          Sign out
        </button>
      </header>
      <main className="app-main">
        {view === 'tenants' && <Tenants />}
        {view === 'audit' && <AuditLog />}
      </main>
      <Toast />
      <footer className="app-footer">
        <span>KeyForge PWA · v0.1.0</span>
      </footer>
    </div>
  );
}
